import { render } from "./VuexTextWithButtonFormItem.vue?vue&type=template&id=e20fabde"
import script from "./VuexTextWithButtonFormItem.vue?vue&type=script&lang=js"
export * from "./VuexTextWithButtonFormItem.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src5135303/src/frontend-broker/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__